import type { IProjectLeftNotificationData } from "@frontend-shared/types";
import { LogOut } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IProjectLeftCardProps {
  uuid: string;
  data: IProjectLeftNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewProject: (organizationUuid: string) => void;
}

const ProjectLeftCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewProject,
}: IProjectLeftCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewProject = useCallback(
    () => onViewProject(data.organizationUuid),
    [onViewProject, data.organizationUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="project_left"
      createdAt={createdAt}
      isRead={isRead}
      icon={<LogOut className="h-5 w-5" />}
      ctaLabel={t("view_project")}
      onCtaClick={handleViewProject}
      body={t("type.project_left.body", {
        leftUserName: data.leftUserName,
        projectTitle: data.projectTitle,
      })}
    />
  );
};

export const ProjectLeftCard = memo(ProjectLeftCardComponent);
